import React, {useState} from "react";
import '../../styles/document.css';
import Translator from "../../services/Translator";
import DefaultLoader from "../loaders/DefaultLoader";
import axios from "axios";
import {config} from "../../config";
import SeriesA from "./identityCard/SeriesA";
import SeriesB from "./identityCard/SeriesB";


export default function IdentityCard({lang, token, show, setCurrentDocument}: any)
{
    const name = 'identity-card';
    const [document, setDocument] = useState<any>(null);
    const [loaded, setLoaded] = useState(false);

    if (show && document === null && !loaded) {
        setLoaded(true);
        axios.get(config.api + '/documents/' + name)
            .then(response => {
                setDocument(response.data);
            })
            .catch(response => console.log(response));
    }

    return (
        <div className="card document">
            <div className="card-header" onClick={() => setCurrentDocument(show ? null : name)}>
                {Translator.trans(lang, "documents.identity_card.name")}
            </div>

            {
                show && document === null ? (
                    <div className="card-body" style={{background: 'rgb(134,170,202) linear-gradient(113deg, rgba(134,170,202,1) 0%, rgba(199,180,124,1) 100%)'}}>
                        <DefaultLoader />
                    </div>
                ) : ''
            }

            {
                show && document !== null ? (
                    (document.identity_card_number[0] === 'A' ? <SeriesA document={document} lang={lang} /> : <SeriesB document={document} token={token} lang={lang} /> )
                ) : ''
            }
        </div>
    );
}
